// @ts-nocheck

import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import { selectRuntimeLicence } from '../../../selectors/runtime/runtimePrimary.selector';
import { storage } from '../../../utils';
import {
  claimAllMPRewards,
  claimMPReward,
  flushNotifications,
  skipAllMPTemporaryNotifications,
  skipCurrentTemporaryNotification,
} from '../actions/mp';
import MPNotification from '../components/MPNotification';
import { MPWelcomeStorage } from '../constants/runtime';
import { useMPModalContext } from '../contexts/MPModalContext';
import { selectMPTmpNotifications } from '../selectors/misc';
import { selectMPNotificationUUIDS } from '../selectors/user';

type MPNotificationContainerProps = {
  className?: string;
};

const MPNotificationContainer = (ownProps: MPNotificationContainerProps) => {
  const { setDisableScrollView, setNotificationUuids } = useMPModalContext();
  const dispatch = useDispatch();
  const notifications = useSelector(selectMPTmpNotifications);
  const licence = useSelector(selectRuntimeLicence);
  const uuids = useSelector(selectMPNotificationUUIDS);
  const hasWelcomed = storage.localStorage.load(MPWelcomeStorage);

  useEffect(() => {
    if (uuids) {
      setNotificationUuids(uuids);
    }
  }, [setNotificationUuids, uuids]);

  useEffect(() => {
    if (notifications.length) {
      setDisableScrollView(true);
      dispatch(flushNotifications());
    } else if (hasWelcomed) {
      setDisableScrollView(false);
    }
  }, [dispatch, hasWelcomed, notifications.length, setDisableScrollView]);

  const selectedProps = useMemo(
    () => ({
      licence,
      notifications,
    }),
    [licence, notifications],
  );

  const actionsProps = useMemo(
    () => ({
      onClaimReward: (uuid) => {
        dispatch(claimMPReward({ uuid }));
      },
      onSkipNotifications: () => {
        dispatch(skipAllMPTemporaryNotifications());
        dispatch(claimAllMPRewards({ uuids }));
      },
      onSkipCurrentNotification: () => {
        dispatch(skipCurrentTemporaryNotification());
      },
    }),
    [dispatch, uuids],
  );

  const enhancedProps = useMergeProps({ actionsProps, ownProps, selectedProps });

  return notifications.length ? <MPNotification {...enhancedProps} /> : null;
};

export default MPNotificationContainer;
